import styled from 'styled-components';
import { contentHeight } from './variables';

export const MapsWrapper = styled.div`
    overflow: hidden;
    background: none !important;
    height: ${contentHeight};
    width: 100%;
`;
